/* eslint-disable */
export default {
  dialer: 'Teclado de marcado',
  allCalls: 'Todas las llamadas',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
